import { createFileRoute, redirect } from "@tanstack/react-router";
import { WorkspaceInviteAcceptPage } from "@/features/workspace-invites/workspace-invite-accept.page";
import { supabase } from "@/lib/supabase";

export const Route = createFileRoute("/invite/$code")({
  beforeLoad: async ({ params }) => {
    const {
      data: { session },
    } = await supabase.auth.getSession();

    if (!session) {
      const isBrowser = typeof window !== "undefined";
      const authFragment = isBrowser ? window.location.hash : "";
      const hasAuthTokens =
        !!authFragment &&
        (() => {
          const searchParams = new URLSearchParams(authFragment.replace(/^#/, ""));
          return searchParams.has("access_token") || searchParams.has("refresh_token");
        })();

      if (hasAuthTokens) {
        return { user: null, session: null };
      }

      throw redirect({
        to: "/signup",
        search: { invite_code: params.code },
        replace: true,
      });
    }

    return { user: session.user, session };
  },
  component: WorkspaceInviteAcceptRoute,
});

function WorkspaceInviteAcceptRoute() {
  const { code } = Route.useParams();
  return <WorkspaceInviteAcceptPage inviteCode={code} />;
}
